module.exports = __webpack_public_path__ + "static/anders-8e168df7f95bdcc43d28e3fbf64b233c.png";